import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import {  useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { Nav, Navbar } from 'react-bootstrap';

import TodayAll from 'components/TimeAll';
import LogoutPage from 'pages/logout';
import MenuInfo from 'data/menu';
import { getBrowserTitle, useTitle } from 'data/data';
// import {ThemeToggle} from "components/ThemeToggleButton";
import LogoImg from "components/LogoImg";
import usePermission from "hooks/usePermission";
import ChangeLanguage from "components/ChangeLanguage";

function NavLink({eventKey, href, className, style, children}) {
  let navigate = useNavigate();
  return (
    <Nav.Item>
      <Nav.Link eventKey={eventKey} href="#" onClick={(eventKey) => { /*console.log(href);*/ navigate(href); }} className={className} style={style}>{children}</Nav.Link>
    </Nav.Item>
  );
}

export default function Navigationbar() {
  const { t } = useTranslation();
  const { name } = useSelector(state => state.user);
  const monitoringMenu = MenuInfo.CMMS;

  const hostname = window.location.hostname;
  const changeTitle = useTitle();
  useEffect(()=>{
    changeTitle(t(getBrowserTitle(hostname)));
  }, [])
  // const fullpath = useLocation().pathname;

  const { hasPermission , isPermissionReady } = usePermission();
  if (!isPermissionReady) {
      return null;
  }
  const visibleMenus = monitoringMenu.children.filter(menu => {
    const permissionOk =
      !menu.permission || hasPermission(menu.permission);

    const featureOk =
      menu.feature === undefined || menu.feature;

    return permissionOk && featureOk;
  });
  
  // const [logoPath, setLogoPath] = useState(Logo);
  // useEffect(()=>{
  //   setLogoPath(mode === 'light' ? Logo1 : Logo);
  // }, [mode])

  const className1 = "dark";
  const className2 = "";
  const className3 = "";
  const className4 = "";
  const className5 = "#FFF";
  return (
    <Navbar collapseOnSelect expand="xxl" bg={className1} variant={className1} className={className2}>
    {/* <Navbar collapseOnSelect expand="xxl" bg="dark" variant="dark"> */}
      <div className='mobile_top'>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Brand href="/"><LogoImg />{/* <img src={logoPath} alt="logo" /> */}</Navbar.Brand>
        <div></div>
      </div>
      
      <div className='pc_account'>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav>
            {
              visibleMenus.map((child) => {
                  return(
            <NavLink key={child.id} eventKey={child.id} href={child.fullpath} className={monitoringMenu.isActive && child.isActive ? "active": ""}>{t(child.name)}</NavLink>
                  )
              })
            }
          </Nav>

          <Nav>
            <TodayAll style={{ color : `${className3}`}}/>
          </Nav>
          
          <Nav style={{alignItems:"center",color:"#fff",fontSize:"1rem"}}>
            <NavLink style={{alignItems:"center",color:`${className5}`,fontSize:"1rem"}}>
              <div style={{display:"flex", alignItems:"center"}}>
                <span className="icon_png"><img src={`${process.env.PUBLIC_URL}/img/icon/account_circle.png`} alt='' /></span>
                <span style={{padding:"0 7px"}}>{name}</span>
              </div>
            </NavLink>
            {/* <ThemeToggle /> */}
            <ChangeLanguage />
            <NavLink href="/"><LogoutPage /></NavLink>
          </Nav>

        </Navbar.Collapse>
      </div>

      <div className={`m_account${className4}`}>
        <Navbar.Collapse id="responsive-navbar-nav">

          <div className='m_account_top'>
            <Nav style={{paddingTop:"3px"}}>
              <TodayAll style={{ color : `${className3}`}}/>
            </Nav>
            
            <Nav className="m_account_in" style={{display:"flex",alignItems:"center",color:`${className5}`,fontSize:"1rem"}}>
              <NavLink style={{alignItems:"center",color:`${className5}`,fontSize:"1rem"}}>
                <div style={{display:"flex", alignItems:"center"}}>
                  <span className="icon_png"><img src={`${process.env.PUBLIC_URL}/img/icon/account_circle.png`} alt='' /></span>
                  <span style={{padding:"0 7px"}}>{name}</span>
                </div>
              </NavLink>
              <NavLink href="/"><LogoutPage /></NavLink>
            </Nav>
          </div>

          <Nav className='dark_menu m_menu_btn'>
            {
              visibleMenus.map((child) => {
                  return (
            <NavLink key={child.id} eventKey={child.id} href={child.fullpath} className={monitoringMenu.isActive && child.isActive ? "active": ""}>{t(child.name)}</NavLink>
                  )
              })
            }
          </Nav>

        </Navbar.Collapse>
      </div>
    </Navbar>
  );
}
